import React from 'react';
import { IconContainer } from './IconContainer';

const IssuesIcon = ({small, ...props}) => {
    return (
        <IconContainer ariaLabel="issues" {...props}>
            {small
                ? <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14.1667 1.66669V3.33335H16.6725C17.1292 3.33335 17.5 3.70419 17.5 4.16085V17.5059C17.5 17.9625 17.1292 18.3334 16.6725 18.3334H3.3275C2.87083 18.3334 2.5 17.9625 2.5 17.5059V4.16085C2.5 3.70419 2.87083 3.33335 3.3275 3.33335H5.83333V1.66669H14.1667ZM5.83333 5.00002H4.16667V16.6667H15.8333V5.00002H14.1667V6.66669H5.83333V5.00002ZM7.5 13.3334V15H5.83333V13.3334H7.5ZM7.5 10.8334V12.5H5.83333V10.8334H7.5ZM7.5 8.33335V10H5.83333V8.33335H7.5ZM12.5 3.33335H7.5V5.00002H12.5V3.33335Z" fill="white"/>
                </svg>
                : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17 2V4H20.007C20.555 4 21 4.445 21 4.993V21.007C21 21.555 20.555 22 20.007 22H3.993C3.445 22 3 21.555 3 21.007V4.993C3 4.445 3.445 4 3.993 4H7V2H17ZM7 6H5V20H19V6H17V8H7V6ZM9 16V18H7V16H9ZM9 13V15H7V13H9ZM9 10V12H7V10H9ZM15 4H9V6H15V4Z" fill="white"/>
                </svg>}
        </IconContainer>
    )
}

export { IssuesIcon };